/* tslint:disable */
/* eslint-disable */
/**
 * Bill Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const UserScoreLevels = {
    Level1: 'Level1',
    Level2: 'Level2',
    Level3: 'Level3',
    Level4: 'Level4'
} as const;

export type UserScoreLevels = typeof UserScoreLevels[keyof typeof UserScoreLevels];



